import axios from 'axios';

async function sendContactEmail(name, email, message) {
  const { data } = await axios.post(
    `${import.meta.env.VITE_API_URL}/email/contact`,
    {
      name, 
      email, 
      message,
    },
  );

  return data;
}

export {
  sendContactEmail,
};